// news-brief 编辑器：category + headlines(title/source/time/color) 增删。
import { useTranslation } from 'react-i18next'
import type { EditorContext } from '../_shared/types'
import type { NewsData } from './types'
import { Field, TextInput, ColorField, Repeater, RemoveButton } from '../../components/editor-controls'

export function NewsBriefEditor({ data, update }: EditorContext) {
  const { t } = useTranslation()
  const d = data as unknown as NewsData
  const headlines = d.headlines || []
  return (
    <>
      <Field label={t('editor.category')}>
        <TextInput value={d.category ?? ''} onChange={(v) => update((dd) => { dd.category = v })} />
      </Field>
      <Field label={t('editor.headlinesCount', { count: headlines.length })}>
        {headlines.map((h, i) => (
          <div className="editable-item col" key={i}>
            <div className="editable-item">
              <span className="ei-rank">{i + 1}</span>
              <TextInput
                value={h.title}
                placeholder={t('editor.headlinePh')}
                style={{ flex: 3 }}
                onChange={(v) => update((dd) => { dd.headlines[i].title = v })}
              />
              <RemoveButton onRemove={() => update((dd) => { dd.headlines.splice(i, 1) })} />
            </div>
            <div className="editable-item">
              <TextInput
                value={h.source}
                placeholder={t('editor.sourcePh')}
                style={{ flex: 1 }}
                onChange={(v) => update((dd) => { dd.headlines[i].source = v })}
              />
              <TextInput
                value={h.time}
                placeholder={t('editor.timePh')}
                style={{ flex: 1 }}
                mono
                onChange={(v) => update((dd) => { dd.headlines[i].time = v })}
              />
            </div>
            <ColorField value={h.color} onChange={(c) => update((dd) => { dd.headlines[i].color = c })} />
          </div>
        ))}
        <Repeater
          addLabel={t('editor.news')}
          onAdd={() =>
            update((dd) => {
              dd.headlines.push({ title: '', source: '', time: '', color: '#6366f1' })
            })
          }
        />
      </Field>
    </>
  )
}
